var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHookFishing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.375 18.25c3.91 19.165-.907 37.814-14.72 55.5-15.853 20.302-44.172 38.85-84.81 51.188-34.84 10.577-58.396 29.203-71 50.937-12.606 21.734-14.02 46.364-5.72 67.5 14.824 37.743 60.4 62.92 121.28 47.438 12.883-4.053 27.47-10 38.97-17.188a84.455 84.455 0 0 0 6.938-4.813 40.986 40.986 0 0 1-9.344-13.031c-13.048 8.047-29.743 16.232-51.532 19.376-47.934 8.963-78.497-12.01-88.938-38.594-6.257-15.93-5.374-34.287 4.5-51.312 9.874-17.025 29.002-32.94 60.28-42.438 43.283-13.14 75.046-33.17 94.095-57.562 15.77-20.194 22.4-43.702 18.906-67h-18.905zm17.844 151.47c-.788 0-1.588 0-2.376.03-11.464.415-23.03 3.582-33.656 9.72-26.423 15.252-39.106 44.164-34.25 72.25 12.21-4.294 22.097-10.274 30.906-16.157 1.418-11.078 7.93-21.27 18.72-27.5 6.337-3.66 13.285-5.464 20.124-5.5 13.055-.07 25.668 6.304 32.656 18.406 10.648 18.44 4.066 42.974-14.375 53.624-8.564 4.945-18.115 5.99-26.97 3.844-4.427 4.08-9.466 7.747-14.72 11.03-5.286 3.306-10.918 6.29-16.655 8.97 15.17 10.68 33.97 15.17 52.25 12.125h.03l72.376 125.406c17.27 29.907 42.53 48.207 68.783 54.467 26.25 6.26 52.74 1.16 74.25-12.03 43.02-26.38 66.36-87.515 33.53-144.376l-16.53-28.655-.157-.28c-19.615-36.032-45.045-60.504-75.344-75.283 12.778 45.916 17.4 91.832 16.094 137.75l28.688-34 4.906-3L443 348.72c21.954 38.025 3.593 72.716-21.125 87.874-35.704 16.537-62.567 12.018-84.625-23.125l-71.78-124.376c20.72-22.425 25.7-57.052 9.78-84.625-13-22.517-36.637-34.833-61.03-34.75z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHookFishing);
export default __webpack_public_path__ + "static/media/hook_fishing.93c3a86888e81d6aef565d7cdfb668fb.svg";
export { ForwardRef as ReactComponent };